/** Pixel icons on a 13×13 grid ('#' = ink, '+' = accent), rendered as crisp SVG. */

const ICONS: Record<string, string[]> = {
  star: [
    '......#......',
    '.....###.....',
    '.....###.....',
    '....#####....',
    '#############',
    '.###########.',
    '..#########..',
    '...#######...',
    '...#######...',
    '..####.####..',
    '..###...###..',
    '.##.......##.',
    '.............',
  ],
  sheet: [
    '..########...',
    '..#......##..',
    '..#......#.#.',
    '..#......####',
    '..#.###.....#',
    '..#.........#',
    '..#.#####...#',
    '..#.........#',
    '..#.####....#',
    '..#.........#',
    '..#.........#',
    '..###########',
    '.............',
  ],
  pause: [
    '.............',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '..###...###..',
    '.............',
    '.............',
  ],
  play: [
    '.............',
    '...#.........',
    '...###.......',
    '...#####.....',
    '...#######...',
    '...#########.',
    '...##########',
    '...#########.',
    '...#######...',
    '...#####.....',
    '...###.......',
    '...#.........',
    '.............',
  ],
  back: [
    '.............',
    '.............',
    '.....#.......',
    '....##.......',
    '...###.......',
    '..##########.',
    '.###########.',
    '..##########.',
    '...###.......',
    '....##.......',
    '.....#.......',
    '.............',
    '.............',
  ],
  next: [
    '.............',
    '.............',
    '.......#.....',
    '.......##....',
    '.......###...',
    '.##########..',
    '.###########.',
    '.##########..',
    '.......###...',
    '.......##....',
    '.......#.....',
    '.............',
    '.............',
  ],
  gear: [
    '.....###.....',
    '..#..###..#..',
    '.###########.',
    '..####.####..',
    '..###...###..',
    '####.....####',
    '####.....####',
    '####.....####',
    '..###...###..',
    '..####.####..',
    '.###########.',
    '..#..###..#..',
    '.....###.....',
  ],
  plane: [
    '.............',
    '.............',
    '..........##.',
    '........###..',
    '......####...',
    '....######...',
    '..#########..',
    '#############',
    '...######....',
    '.....####....',
    '.......##....',
    '.............',
    '.............',
  ],
  check: [
    '.............',
    '.............',
    '..........##.',
    '.........###.',
    '........###..',
    '.##....###...',
    '.###..###....',
    '..######.....',
    '...####......',
    '....##.......',
    '.............',
    '.............',
    '.............',
  ],
  lock: [
    '.............',
    '....#####....',
    '...##...##...',
    '...#.....#...',
    '...#.....#...',
    '..#########..',
    '..#########..',
    '..####.####..',
    '..####.####..',
    '..#########..',
    '..#########..',
    '.............',
    '.............',
  ],
  close: [
    '.............',
    '.##.......##.',
    '.###.....###.',
    '..###...###..',
    '...###.###...',
    '....#####....',
    '.....###.....',
    '....#####....',
    '...###.###...',
    '..###...###..',
    '.###.....###.',
    '.##.......##.',
    '.............',
  ],
  plus: [
    '.............',
    '.....###.....',
    '.....###.....',
    '.....###.....',
    '.....###.....',
    '.###########.',
    '.###########.',
    '.###########.',
    '.....###.....',
    '.....###.....',
    '.....###.....',
    '.....###.....',
    '.............',
  ],
  minus: [
    '.............',
    '.............',
    '.............',
    '.............',
    '.............',
    '.###########.',
    '.###########.',
    '.###########.',
    '.............',
    '.............',
    '.............',
    '.............',
    '.............',
  ],
  undo: [
    '.............',
    '....#........',
    '...##........',
    '..##########.',
    '.###########.',
    '..##.......##',
    '...#........#',
    '............#',
    '............#',
    '...........##',
    '.....#######.',
    '.....######..',
    '.............',
  ],
  redo: [
    '.............',
    '........#....',
    '........##...',
    '.##########..',
    '.###########.',
    '##.......##..',
    '#........#...',
    '#............',
    '#............',
    '##...........',
    '.#######.....',
    '..######.....',
    '.............',
  ],
  clock: [
    '....#####....',
    '..##.....##..',
    '.#....#....#.',
    '.#....#....#.',
    '#.....#.....#',
    '#.....#.....#',
    '#.....####..#',
    '#...........#',
    '#...........#',
    '.#.........#.',
    '.#.........#.',
    '..##.....##..',
    '....#####....',
  ],
  drop: [
    '......#......',
    '......#......',
    '.....###.....',
    '.....###.....',
    '....#####....',
    '...#######...',
    '..###.#####..',
    '..##.######..',
    '..##.######..',
    '..#########..',
    '...#######...',
    '....#####....',
    '.............',
  ],
  flame: [
    '......#......',
    '.....##......',
    '.....###.....',
    '....####.#...',
    '...######.#..',
    '...#########.',
    '..####.######',
    '..###...#####',
    '..###...####.',
    '...##...###..',
    '....#######..',
    '.....#####...',
    '.............',
  ],
  battery: [
    '.............',
    '.............',
    '.##########..',
    '.#........##.',
    '.#.###.##..#.',
    '.#.###.###.#.',
    '.#.###.###.#.',
    '.#.###.##..#.',
    '.#........##.',
    '.##########..',
    '.............',
    '.............',
    '.............',
  ],
  home: [
    '......#......',
    '.....###.....',
    '....##.##....',
    '...##...##...',
    '..##.....##..',
    '.###########.',
    '..#.......#..',
    '..#.###...#..',
    '..#.#.#...#..',
    '..#.#.#...#..',
    '..#.#.#...#..',
    '..#########..',
    '.............',
  ],
  trophy: [
    '..#########..',
    '..#########..',
    '###.#####.###',
    '#.#.#####.#.#',
    '#..#######..#',
    '.#.#######.#.',
    '...#######...',
    '....#####....',
    '.....###.....',
    '.....###.....',
    '....#####....',
    '...#######...',
    '.............',
  ],
  share: [
    '......#......',
    '.....###.....',
    '....#####....',
    '......#......',
    '......#......',
    '......#......',
    '.##...#...##.',
    '.#.........#.',
    '.#.........#.',
    '.#.........#.',
    '.###########.',
    '.............',
    '.............',
  ],
  copy: [
    '.............',
    '....#######..',
    '....#.....#..',
    '.#######..#..',
    '.#.....#..#..',
    '.#.....#..#..',
    '.#.....#..#..',
    '.#.....####..',
    '.#.....#.....',
    '.#.....#.....',
    '.#######.....',
    '.............',
    '.............',
  ],
  trash: [
    '.....###.....',
    '.###########.',
    '.............',
    '..#########..',
    '..#.#.#.#.#..',
    '..#.#.#.#.#..',
    '..#.#.#.#.#..',
    '..#.#.#.#.#..',
    '..#.#.#.#.#..',
    '..#.#.#.#.#..',
    '..#########..',
    '.............',
    '.............',
  ],
  bulb: [
    '....#####....',
    '...#.....#...',
    '..#..++...#..',
    '..#.+.....#..',
    '..#.......#..',
    '...#.....#...',
    '....#...#....',
    '....#####....',
    '....#####....',
    '.....###.....',
    '.............',
    '.............',
    '.............',
  ],
  chart: [
    '.............',
    '.#...........',
    '.#.........#.',
    '.#........#..',
    '.#...#...#...',
    '.#..#.#.#....',
    '.#.#...#.....',
    '.##..........',
    '.#...........',
    '.###########.',
    '.............',
    '.............',
    '.............',
  ],
  ghost: [
    '....#####....',
    '...#######...',
    '..#########..',
    '..##.###.##..',
    '..##.###.##..',
    '..#########..',
    '..#########..',
    '..#########..',
    '..#########..',
    '..##.###.##..',
    '..#...#...#..',
    '.............',
    '.............',
  ],
  clip: [
    '...######....',
    '..#......#...',
    '..#.####.#...',
    '..#.#..#.#...',
    '..#.#..#.#...',
    '..#.#..#.#...',
    '..#.#..#.#...',
    '..#.#....#...',
    '..#.######...',
    '..#..........',
    '...#######...',
    '.............',
    '.............',
  ],
  balloon: [
    '....#####....',
    '...#######...',
    '..#########..',
    '..####.####..',
    '..###.#####..',
    '..#########..',
    '...#######...',
    '....#####....',
    '......#......',
    '.....#.......',
    '......#......',
    '.....#.......',
    '.............',
  ],
  calendar: [
    '..#.....#....',
    '############.',
    '#..........#.',
    '############.',
    '#.##.##.##.#.',
    '#.##.##.##.#.',
    '#..........#.',
    '#.##.##.++.#.',
    '#.##.##.++.#.',
    '#..........#.',
    '############.',
    '.............',
    '.............',
  ],
  target: [
    '....#####....',
    '..##.....##..',
    '.#....#....#.',
    '.#..#####..#.',
    '#..##...##..#',
    '#..#..#..#..#',
    '#.##.###.##.#',
    '#..#..#..#..#',
    '#..##...##..#',
    '.#..#####..#.',
    '.#....#....#.',
    '..##.....##..',
    '....#####....',
  ],
  pin: [
    '....#####....',
    '...#######...',
    '..###...###..',
    '..##.....##..',
    '..###...###..',
    '...#######...',
    '....#####....',
    '.....###.....',
    '.....###.....',
    '......#......',
    '.............',
    '.............',
    '.............',
  ],
  cards: [
    '.............',
    '..######.....',
    '..#....######',
    '..#....#....#',
    '..#....#....#',
    '..#....#....#',
    '..#....#....#',
    '..######....#',
    '.......######',
    '.............',
    '.............',
    '.............',
    '.............',
  ],
  fold: [
    '.###########.',
    '.#.........#.',
    '.#........#..',
    '.#.......#.#.',
    '.#......#..#.',
    '.#.....#...#.',
    '.#....#....#.',
    '.#...#.....#.',
    '.#..#......#.',
    '.#.#.......#.',
    '.##........#.',
    '.###########.',
    '.............',
  ],
  sound: [
    '.............',
    '......#......',
    '.....##...#..',
    '..####.#...#.',
    '..####.#.#.#.',
    '..####.#.#.#.',
    '..####.#...#.',
    '.....##...#..',
    '......#......',
    '.............',
    '.............',
    '.............',
    '.............',
  ],
  tape: [
    '.............',
    '....#####....',
    '..##.....##..',
    '.#...###...#.',
    '.#..#...#..#.',
    '.#..#...#..#.',
    '.#...###...#.',
    '..##.....#####',
    '....#####....',
    '.............',
    '.............',
    '.............',
    '.............',
  ],
  eye: [
    '.............',
    '.............',
    '....#####....',
    '..##.....##..',
    '.#...###...#.',
    '#...#####...#',
    '#...#####...#',
    '.#...###...#.',
    '..##.....##..',
    '....#####....',
    '.............',
    '.............',
    '.............',
  ],
  refresh: [
    '.............',
    '....#####.#..',
    '..##.....##..',
    '.#......###..',
    '.#...........',
    '#............',
    '#...........#',
    '............#',
    '...........#.',
    '..###......#.',
    '..##.....##..',
    '..#.#####....',
    '.............',
  ],
  info: [
    '....#####....',
    '..##.....##..',
    '.#....#....#.',
    '.#.........#.',
    '#....##.....#',
    '#.....#.....#',
    '#.....#.....#',
    '#.....#.....#',
    '#....###....#',
    '.#.........#.',
    '.#.........#.',
    '..##.....##..',
    '....#####....',
  ],
  wing: [
    '.............',
    '.............',
    '#............',
    '##...........',
    '#.##.........',
    '#...##.......',
    '#.....##.....',
    '#.......##...',
    '#.........##.',
    '#############',
    '.............',
    '.............',
    '.............',
  ],
  medal: [
    '.##.....##...',
    '..##...##....',
    '...##.##.....',
    '....###......',
    '...#####.....',
    '..##+++##....',
    '..#+++++#....',
    '..#+++++#....',
    '..##+++##....',
    '...#####.....',
    '.............',
    '.............',
    '.............',
  ],
};

export type IconName = keyof typeof ICONS;

const cache = new Map<string, string>();

function pathFor(name: string, ch: string): string {
  const key = `${name}:${ch}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  const rows = ICONS[name] ?? [];
  let d = '';
  rows.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (row[x] === ch) {
        let x2 = x;
        while (x2 < row.length && row[x2] === ch) x2++;
        d += `M${x} ${y}h${x2 - x}v1h${-(x2 - x)}z`;
        x = x2;
      } else x++;
    }
  });
  cache.set(key, d);
  return d;
}

export function Icon(props: { name: IconName | string; accent?: string; class?: string; title?: string }) {
  const d = pathFor(props.name, '#');
  const a = pathFor(props.name, '+');
  return (
    <svg class={`icon ${props.class ?? ''}`} viewBox="0 0 13 13" aria-hidden={props.title ? undefined : 'true'} role={props.title ? 'img' : undefined}>
      {props.title && <title>{props.title}</title>}
      <path d={d} fill="currentColor" />
      {a && <path d={a} fill={props.accent ?? 'var(--mustard)'} />}
    </svg>
  );
}
